window.$ = window.jQuery = require("jquery");
require("./components");
require("./pages");
///https://web.dev/use-lazysizes-to-lazyload-images/
require('./lazysizes.min.js');

document.addEventListener("DOMContentLoaded", function (event) {
    setTimeout(() => {
        $("body").removeClass("preload");
    }, 1000);
});


